<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4 xl3>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <br>
                  <img src="/static/logo.png" alt="Logo" width="240">
                  <h2 class="flex my-4 primary--text">Quên mật khẩu</h2>
                </div>
                <v-form v-model="formValid" ref="form">
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Email hoặc SĐT"
                    type="text"
                    v-model="valueText"
                    :rules="[validate.required]"
                    @keydown.enter.prevent="submit()"
                  ></v-text-field>
                  <br>
                  <v-btn
                    block
                    round
                    color="black"
                    :loading="isLoading"
                    class="login-btn"
                    @click="submit()"
                  >Lấy lại mật khẩu</v-btn>
                  <br>
                  <v-layout align-center justify-center>
                    <v-btn flat small to="/login">Quay lại đăng nhập</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    validate: validate,
    formValid: false,
    isLoading: false,
    valueText: '',
    phone: '',
    email: ''
  }),
  created () {
    this.valueText = '';
  },
  methods: {
    ...mapActions(['requestOtp']),
    ...mapMutations(['SET_FORGOT_PASSWORD_EMAIL', 'SET_FORGOT_PASSWORD_PHONE']),
    submit () {
      if (this.formValid && this.validateText()) {
        let data = {
          email: this.email,
          phone: this.phone
        };
        this.requestOtp(data)
          .then(res => {
            this.isLoading = false;
            this.SET_FORGOT_PASSWORD_EMAIL(this.email);
            this.SET_FORGOT_PASSWORD_PHONE(this.phone);
            window.location.href = `#/confirmotp`;
          })
          .catch(err => {
            this.isLoading = false;
            let message = 'Có lỗi xảy ra, vui lòng thử lại';
            if (err.code === 'ERR_EMAIL_NOT_EXIST') {
              message = 'Email không tồn tại trong hệ thống';
            }
            if (err.code === 'ERR_PHONE_NOT_EXIST') {
              message = 'Số điện thoại không tồn tại trong hệ thống';
            }
            window.getApp.showMessage(message, 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    },

    validateText () {
      this.email = '';
      this.phone = '';
      if (Number(this.valueText)) {
        this.phone = this.valueText.trim();
        return true;
      }

      let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailPattern.test(this.valueText)) {
        this.email = this.valueText.trim();
        return true;
      }
      this.showMessage('Vui lòng nhập dúng định dạng!', 'error');
      return false;
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.login-btn {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/forgotpassword/index.vue